import { ShieldCheck } from "lucide-react";

/**
 * CRITICAL COMPLIANCE COMPONENT
 * Renders "Payment executed by Finshark" – never "Shwiip sent / processed".
 * variant: "pill" | "banner" | "inline"
 */
export const PartnerBadge = ({
  partner = "Finshark",
  variant = "pill",
  prefix = "Payment executed by",
  className = "",
  testId = "partner-attribution",
}) => {
  if (variant === "banner") {
    return (
      <div
        data-testid={testId}
        className={
          "flex items-start gap-3 rounded-2xl border border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-white/5 p-4 " +
          className
        }
      >
        <div className="flex-shrink-0 w-9 h-9 rounded-full bg-white dark:bg-white/10 border border-slate-200 dark:border-white/10 flex items-center justify-center">
          <ShieldCheck className="w-5 h-5 text-slate-700 dark:text-emerald-400" strokeWidth={2.2} />
        </div>
        <div className="min-w-0">
          <div className="text-[13px] font-semibold text-slate-900 dark:text-white leading-tight">
            {prefix} <span className="font-bold">{partner}</span>
          </div>
          <div className="text-[11px] text-slate-500 dark:text-gray-400 mt-1 leading-snug">
            Shwiip acts as a technical interface only. Funds are handled by {partner},
            a licensed PSP.
          </div>
        </div>
      </div>
    );
  }

  if (variant === "inline") {
    return (
      <div
        data-testid={testId}
        className={"flex items-center gap-1.5 text-[11px] text-slate-500 dark:text-gray-400 " + className}
      >
        <ShieldCheck className="w-3 h-3" strokeWidth={2.5} />
        <span>
          Executed by <span className="font-semibold text-slate-700 dark:text-gray-300">{partner}</span>
        </span>
      </div>
    );
  }

  // pill
  return (
    <div
      data-testid={testId}
      className={
        "inline-flex items-center gap-2 rounded-full border border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-white/10 px-3 py-1.5 text-[11px] font-semibold text-slate-600 dark:text-gray-300 " +
        className
      }
    >
      <ShieldCheck className="w-3.5 h-3.5 text-slate-700 dark:text-emerald-400" strokeWidth={2.5} />
      <span className="tracking-wide">
        {prefix} <span className="text-slate-900 dark:text-white">{partner}</span>
      </span>
    </div>
  );
};

export default PartnerBadge;
